// extracted by mini-css-extract-plugin
export var content = "_e5-3";
export var list = "_e5-4";
export var settingsContent = "_e5-7";
export var settingsPanel = "_e5-8";
export var state = "_e5-6";
export var triggerBadge = "_e5-2";
export var triggerButton = "_e5-1";
export var triggerShell = "_e5-0";
export var unreadDot = "_e5-5";